<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
<template>
  <b-dropdown v-bind="$attrs"
              ref="sdropdown"
              data-test="sdropdown"
              v-on="$listeners"
              @show="captureScrollPosition"
              @shown="restoreScrollPosition"
  >
    <template #button-content v-if="!$attrs['text']">
      <slot name="button-content" />
    </template>
    <template #default>
      <slot name="default" />

      <template v-if="shouldDisplayCloseButton">
        <li data-test="close-dropdown-button-divider"
            class="dropdown-divider"
            aria-hidden="true"
        />
        <SDropDownCloseButton @close-dropdown="closeDropDown" />
      </template>
    </template>
  </b-dropdown>
</template>

<script>
import SDropDownCloseButton from 'src/components/base/SDropDown/SDropDownCloseButton.vue'
export default {
  name: 'SDropDown',

  components: {
    SDropDownCloseButton,
  },

  props: {
    forceShowCloseButton: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    scrollAncestor: null,
    savedScrollTop: 0,
  }),

  computed: {
    shouldDisplayCloseButton() {
      return this.isA11yDemoSchool || this.forceShowCloseButton
    },

    isA11yDemoSchool() {
      return this.$isA11yDemoSchool()
    },
  },

  methods: {
    closeDropDown() {
      this.$refs?.sdropdown?.hide()
    },

    // Opening the dropdown focuses its menu for keyboard a11y, which makes the browser
    // auto-scroll the nearest scrollable ancestor into view. On short pages the menu's
    // own (absolutely positioned) height can exceed that ancestor's visible area, so the
    // auto-scroll ends up shoving the whole page out of view. We snapshot the scroll
    // position before it happens and restore it right after, cancelling just that jump.
    captureScrollPosition() {
      this.scrollAncestor = this.findScrollableAncestor(this.$el)
      this.savedScrollTop = this.scrollAncestor?.scrollTop
    },

    restoreScrollPosition() {
      if (this.scrollAncestor) this.scrollAncestor.scrollTop = this.savedScrollTop
    },

    findScrollableAncestor(el) {
      let node = el?.parentElement
      while (node && node !== document.documentElement) {
        if (['auto', 'scroll', 'hidden'].includes(getComputedStyle(node).overflowY)) return node
        node = node.parentElement
      }
      return null
    },
  },
}
</script>
